/**
 * This file contains zod type equivalents for all of the runtype type
 * brands that we have in hex.
 *
 * TODO(EDT-190): Find a way to programatically map the database Ids to zod types
 * instead of writing these manually.
 */
import { z } from "zod";

import {
  AgentChatThreadId,
  AppSessionId,
  CellId,
  DataConnectionId,
  DataSourceTableId,
  DisplayTableColumnId,
  GridLayoutId,
  GridRowId,
  HexId,
  OrgGuideFileVersionId,
  OrgId,
  SemanticProjectFileId,
  SemanticProjectId,
} from "../idTypeBrands.js";

export const zOrgId = z.string().transform((val) => val as OrgId);
export const zCellId = z.string().transform((val) => val as CellId);
const OUTPUT_NAME_DESCRIPTION =
  "The name of the output variable for this cell. Must be lowercase snake_case (matching `^[a-z_][a-z0-9_]*$`) and unique across all cells. When set, the cell's result is accessible as a named dataframe.";

export const zOutputName = z
  .string()
  .regex(/^[a-z_][a-z0-9_]*$/, "Must be lowercase snake_case.")
  .describe(OUTPUT_NAME_DESCRIPTION);
export const zOptionalOutputName = zOutputName
  .describe(`Optional. ${OUTPUT_NAME_DESCRIPTION}`)
  .nullish();
export const zHexId = z.string().transform((val) => val as HexId);
export const zAppSessionId = z.string().transform((val) => val as AppSessionId);
export const zDataSourceTableId = z
  .string()
  .transform((val) => val as DataSourceTableId)
  .describe("A tableId (uuid) for a table.");
export const zDataConnectionId = z
  .string()
  .transform((val) => val as DataConnectionId);

export const zDisplayTableColumnId = z
  .string()
  .transform((val) => val as DisplayTableColumnId);

export const zAgentChatThreadId = z
  .string()
  .transform((v) => v as AgentChatThreadId);

export const zGridLayoutId = z.string().transform((val) => val as GridLayoutId);

export const zGridRowId = z.string().transform((val) => val as GridRowId);

export const zOrgGuideFileVersionId = z
  .string()
  .transform((val) => val as OrgGuideFileVersionId);

export const zSemanticProjectFileId = z
  .string()
  .transform((val) => val as SemanticProjectFileId);

export const zSemanticProjectId = z
  .string()
  .transform((val) => val as SemanticProjectId);
